"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarFeedback = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const SideBarOpenStateStore_1 = __importDefault(require("../utils/zustand-stores/SideBarOpenStateStore"));
function SideBarFeedback({ onClick }) {
    const { setOpen } = (0, SideBarOpenStateStore_1.default)();
    const theme = (0, material_1.useTheme)();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "flex flex-col gap-[1rem]" },
            react_1.default.createElement(material_1.Typography, { variant: "body1", color: 'white' }, "Need Help?"),
            react_1.default.createElement(material_1.Typography, { variant: "body2", color: 'white' }, "We'd love to hear your thoughts! How can we improve your experience?"),
            react_1.default.createElement("div", { className: "flex items-start" },
                react_1.default.createElement(material_1.Button, { variant: "outlined", sx: {
                        fontFamily: 'Effra',
                        fontSize: '0.8125rem',
                        fontWeight: 500,
                        lineHeight: '1.375rem',
                        letterSpacing: '0.02875rem',
                        color: theme.palette.primary.contrastText,
                        padding: '0.25rem 0.625rem',
                        border: '1px solid #0E848480',
                    }, onClick: e => {
                        setOpen(false);
                        if (onClick) {
                            onClick(e);
                        }
                    } }, "Share your feedback")))));
}
exports.SideBarFeedback = SideBarFeedback;
